// src/components/common/ImagenUploader.js
// ---------------------------------------------------------------
// Componente reutilizable para subir una imagen con preview.
// Antes vivia como componente local dentro de AdminCertificados.js;
// movido aqui para que lo usen tambien AdminDashboard (imagen hero
// del curso) y cualquier otro flujo de imagen puntual.
//
// Props:
//   label      — titulo que se muestra arriba del area
//   preview    — URL (o data URI) para mostrar la imagen actual
//   disabled   — bloquea el input (p.ej. mientras no exista el id
//                del recurso al que subir)
//   uploading  — muestra "Subiendo…" en el boton principal
//   onPick(f)  — callback con el File seleccionado por el usuario
//   onClear()  — callback para quitar la imagen (opcional)
//   fondo      — color de fondo del area (util cuando la imagen es
//                clara sobre tema claro o viceversa)
//   hint       — texto gris pequeno debajo
// ---------------------------------------------------------------
import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';

export default function ImagenUploader({
  label, preview, disabled, uploading, onPick, onClear, fondo, hint,
}) {
  const inputRef = React.useRef(null);
  return (
    <Box sx={{ flex: 1 }}>
      {label && (
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
          {label}
        </Typography>
      )}
      <Box sx={{
        border: '1px dashed',
        borderColor: disabled ? 'action.disabledBackground' : 'divider',
        borderRadius: 1, p: 1.5, bgcolor: fondo || 'transparent',
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        gap: 1, minHeight: 160, justifyContent: 'center',
      }}>
        {preview ? (
          <Box
            component="img"
            src={preview}
            alt={label || 'imagen'}
            sx={{ maxHeight: 110, maxWidth: '100%', objectFit: 'contain' }}
          />
        ) : (
          <Typography variant="caption" color="text.secondary">
            Sin imagen
          </Typography>
        )}
        <input
          ref={inputRef}
          type="file"
          hidden
          accept="image/png,image/jpeg,image/webp,image/svg+xml"
          onChange={(e) => {
            const f = e.target.files?.[0];
            if (f) onPick(f);
            e.target.value = '';
          }}
        />
        <Stack direction="row" spacing={1}>
          <Button
            size="small"
            variant="outlined"
            disabled={disabled}
            onClick={() => inputRef.current?.click()}
          >
            {uploading ? 'Subiendo…' : (preview ? 'Cambiar' : 'Subir imagen')}
          </Button>
          {preview && onClear && (
            <Button size="small" color="error" onClick={onClear} disabled={disabled}>
              Quitar
            </Button>
          )}
        </Stack>
      </Box>
      {hint && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 0.5, display: 'block' }}
        >
          {hint}
        </Typography>
      )}
    </Box>
  );
}
